const customSelectBox = () => {
    var customSelect = $(document).find('.custom-mv-select');
    customSelect.each(function () {
        var thisCustomSelect = $(this);
        if (!thisCustomSelect.attr('data-custom')) {
            thisCustomSelect.attr('data-custom', true);
            var isRequired = thisCustomSelect.find('select').attr('required');

            var options = thisCustomSelect.find('option');
            var optionsSelected = thisCustomSelect.find('option:selected').text();
            var optionValue = thisCustomSelect.find('option:selected').attr('id');
            var sortText = $("#sort-order").attr('aria-label');
            var selectedItem;
            if (optionsSelected) {
                if (thisCustomSelect.hasClass('sortOrderList')) {
                    selectedItem = $('<div></div>', {
                        class: 'selected-item',
                    })
                        .appendTo(thisCustomSelect)
                        .html(`${sortText}:<b>${optionsSelected}</b>`);
                } else {
                    selectedItem = $('<div></div>', {
                        class: 'selected-item',
                    })
                        .appendTo(thisCustomSelect)
                        .html(`<span class="option-selected">${optionsSelected}</span>`);
                }
            } else {
                selectedItem = $('<div></div>', {
                    class: 'selected-item',
                })
                    .appendTo(thisCustomSelect)
                    .html('<span style="color:#757575">Please select</span>');
            }

            if (isRequired !== '' && optionValue === '') {
                thisCustomSelect.addClass('is-invalid');
            }

            var allItems = $('<div></div>', {
                class: 'all-items all-items-hide',
            }).appendTo(thisCustomSelect);

            $('body').on('click', () => {
                if ($('.all-items:not(.all-items-hide)').length) {
                    thisCustomSelect.find('.all-items').addClass('all-items-hide');
                    thisCustomSelect.find('.selected-item').removeClass('arrowanim');
                }
            });

            options.each(function () {
                var that = $(this);
                var optionText = that.text();
                if (that.val() !== '') {
                    $('<div></div>', {
                        class: 'custom-item',
                        value: that.val(),
                        on: {
                            click() {
                                var selectedOptionText = that.text();
                                sessionStorage.setItem('sortSelected', selectedOptionText);
                                selectedItem.text(selectedOptionText).removeClass('arrowanim');
                                allItems.addClass('all-items-hide');
                                thisCustomSelect.find('option:selected').removeAttr('selected');
                                var sortText = $("#sort-order").attr('aria-label');
                                if (that.parents('select#sort-order').length) {
                                    // added to make selected item bold on every time user click
                                    $('.sortOrderList .all-items .custom-item').removeClass('selectedOption');
                                    $('.sortOrderList .all-items .custom-item').each(function () {
                                        let isSelected = $(this).text().trim() === selectedOptionText.trim();
                                        if (isSelected) $(this).attr('style', 'font-weight:600').addClass('selectedOption');
                                        else $(this).attr('style', 'font-weight:400');
                                    });
                                    $.spinner().start();
                                    let url = $('#customerNoUrl').val();
                                    let customerId = "";
                                    $.ajax({
                                        url,
                                        type: 'get',
                                        success(data) {
                                            if (data.customerId) {
                                                customerId = data.customerId;
                                            }
                                        },
                                        error() {
                                            console.error('Error fetching content:', error);
                                        },
                                    });
                                    $.ajax({
                                        url: that.val(),
                                        data: { selectedUrl: that.val() },
                                        method: 'GET',
                                        success(response) {
                                            $('.product-grid').empty().html(response);
                                            var filterData = $($.parseHTML(response)).filter(".searchAjaxGAFilter");
                                            var filterDataGA = JSON.parse(filterData.text());
                                            if (filterDataGA) {
                                                filterDataGA.userID = customerId;
                                                window.dataLayer.push(filterDataGA);
                                            }
                                            selectedItem.html(`${sortText}:<b>${selectedOptionText}</b>`).removeClass('arrowanim');
                                            $.spinner().stop();                                           
                                        },
                                        error() {
                                            $.spinner().stop();
                                        },
                                    });
                                }
                            },
                        },
                    })
                        .appendTo(allItems)
                        .text(optionText);
                }
            });
            // added to make selected item bold on initial render
            $('.sortOrderList .all-items .custom-item').each(function () {
                let isSelected = $(this).text().trim() === optionsSelected.trim();
                if (isSelected) $(this).attr('style', 'font-weight:600').addClass('selectedOption');
                else $(this).attr('style', 'font-weight:400');
            });
        }
    });

    var selectedItem = $('.selected-item');
    var allItems = $('.all-items');

    selectedItem.on('click', function (e) {
        var currentSelectedItem = $(this);

        var currentAllItems = currentSelectedItem.next('.all-items');

        allItems.not(currentAllItems).addClass('all-items-hide');
        selectedItem.not(currentSelectedItem).removeClass('arrowanim');

        currentAllItems.toggleClass('all-items-hide');
        currentSelectedItem.toggleClass('arrowanim');

        e.stopImmediatePropagation();
    });

    $(document).on('click', () => {
        var opened = $('.all-items:not(.all-items-hide)');
        var index = opened.parent().index();

        customSelect
            .eq(index)
            .find('.all-items')
            .addClass('all-items-hide');
        customSelect
            .eq(index)
            .find('.selected-item')
            .removeClass('arrowanim');
    });
};

$(() => {
    customSelectBox();
});


module.exports = {
    customSelectBox,
};
